/**
 * Document API path construction, centralized so the scope rule lives in one
 * place (and is unit-testable).
 *
 * Only CREATE and LIST are scope-specific — a document is created into / listed
 * for a project or a property. Every id-addressed operation (confirm, download,
 * update, delete, grants, ai-review) is registered on the API ONLY under the
 * property path, because a document id is unique within a property regardless of
 * its scope. Building an id-addressed URL off the project path 404s.
 */

/** Create/list collection for property-scoped documents. */
export function propertyBasePath(propertyId: string): string {
	return `/api/common/properties/${propertyId}/documents`
}

/** Create/list collection for project-scoped documents. */
export function projectBasePath(propertyId: string, projectId: string): string {
	return `/api/common/properties/${propertyId}/projects/${projectId}/documents`
}

/**
 * Base path for a single document by id — the property path, used by ALL
 * id-addressed operations regardless of whether the document is project- or
 * property-scoped.
 */
export function documentResourcePath(
	propertyId: string,
	documentId: string,
): string {
	return `${propertyBasePath(propertyId)}/${documentId}`
}
